import Vue from 'vue';
import types from './mutation-types';

export default {
  setLargeData(state, data) {
    state.activeRevisions = data;
  },
  [types.DECREMENT_LOADER](state) {
    state.loading -= 1;
  },

  [types.INCREMENT_LOADER](state) {
    state.loading += 1;
  },

  [types.SET_VIEW_BREADCRUMBS](state, options) {
    Vue.set(state.breadcrumbs, options.view, options.breadcrumbs);
  },

  [types.RESET_VIEW_BREADCRUMBS](state, view) {
    Vue.delete(state.breadcrumbs, view);
  },

  [types.SET_SIGNED_IN](state, signInState) {
    Vue.set(state, 'isSignedIn', signInState);
  },
};



// WEBPACK FOOTER //
// ./store/mutations.js